import React, { Component, useState, useEffect } from 'react';
import Title from './Title';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Paper from '@mui/material/Paper';
import Badge from '@mui/material/Badge';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SensorsIcon from '@mui/icons-material/Sensors';
import ArticleIcon from '@mui/icons-material/Article';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';


import DissolvedGases from '../components/tables/DissolvedGases';
import IECCodes from '../components/tables/IECCodes';
import LEDTChart from '../components/charts/LEDTChart';
import RValue from '../components/charts/RValue';
import HydrocarbonTrend from '../components/charts/HydrocarbonTrend';
import DuvalReport from '../components/charts/DuvalReport';
import WeibullChart from '../components/charts/WeibullChart';

class PredictionAnalytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            equipId: 0,
            transformer: false,
            circuitBreaker: false
        }
    }

    componentDidMount() {

        this.interval = setInterval(() => {
            var id = document.getElementById("selectedEquipmentId").innerText

            switch (id) {
                case "188":
                    this.setState({ transformer: true, circuitBreaker: false, equipId: id })
                    break;
                case "191":
                    this.setState({ transformer: true, circuitBreaker: false, equipId: id })
                    break;
                case "466":
                    this.setState({ transformer: true, circuitBreaker: false, equipId: id })
                    break;
                case "288":
                    this.setState({ transformer: true, circuitBreaker: false, equipId: id })
                    break;
                case "186":
                    this.setState({ transformer: false, circuitBreaker: true, equipId: id })
                    break;
                case "460":
                    this.setState({ transformer: false, circuitBreaker: true, equipId: id })
                    break;
                case "182":
                    this.setState({ transformer: false, circuitBreaker: true, equipId: id })
                    break;
                case "149":
                    this.setState({ transformer: false, circuitBreaker: true, equipId: id })
                    break;
                default:
                    this.setState({ transformer: false, circuitBreaker: false, equipId: id })
            }
            this.setState({ equipId: id })
        }, 1000);

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }



    render() {

        return (
            <React.Fragment>
                <Title>Equipment Analysis</Title>
                <Grid container spacing={12}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper elevation={6}>Asset Id selected:<div id="selectedEquipmentId"></div></Paper>
                        <br/>
                        {this.state.transformer && <><Paper elevation={6}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography variant="h6" >Digital Thread</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <Stack spacing={2}>
                                            <Paper elevation={3}>
                                                Category:
                                                <b>{this.state.transformer && 'Transformer'}</b>                                                
                                            </Paper>
                                            <Paper elevation={3}>Installation Date: <b>March 20, 2016</b><br />
                                                Operating Age: <b>52,241 hrs</b><br />
                                                Down Time: <b>3,134 hrs</b><br />
                                                Criticality: <b>Level 3 </b><br />
                                            </Paper>
                                            <Paper elevation={3}>Work Orders: <Badge badgeContent={6} color="primary"><WorkHistoryIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button><br />
                                                Alarms and Notices: <Badge badgeContent={12} color="primary"><NotificationsNoneIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button><br />
                                                Connected Sensors: <Badge badgeContent={3} color="primary"><SensorsIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button><br />
                                                Manufacturers docs: <Badge badgeContent={2} color="primary"><ArticleIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button>
                                            </Paper>
                                        </Stack>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </Paper> <br/></>}
                       
                        {this.state.transformer && <><Paper elevation={6}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panelxfrmr-content"
                                    id="panelxfrmr-header"
                                >
                                    <Typography variant="h6" >Transformer On-line Oil Assessment Report</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="xfrmr1-content"
                                            id="xfrmr1-header"
                                        >
                                            <Typography variant="h6" >Dissolved Gases</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                <Stack spacing={2}>
                                                    <DissolvedGases />
                                                </Stack>
                                            </Typography>
                                        </AccordionDetails>

                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="xfrmr2-content"
                                            id="xfrmr2-header"
                                        >
                                            <Typography variant="h6">IEC Codes</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                <Stack spacing={2}>
                                                    <IECCodes />
                                                </Stack>
                                            </Typography>
                                        </AccordionDetails>

                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="xfrmr3-content"
                                            id="xfrmr3-header"
                                        >
                                            <Typography variant="h6">LEDT</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                <Stack spacing={2}>
                                                    <LEDTChart />
                                                </Stack>
                                            </Typography>
                                        </AccordionDetails>

                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="xfrmr4-content"
                                            id="xfrmr4-header"
                                        >
                                            <Typography variant="h6">R-Value</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <RValue />
                                        </AccordionDetails>

                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="xfrmr5-content"
                                            id="xfrmr5-header"
                                        >
                                            <Typography variant="h6">Hydrocarbon Trend</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <HydrocarbonTrend />
                                        </AccordionDetails>

                                    </Accordion>

                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="xfrmr6-content"
                                            id="xfrmr6-header"
                                        >
                                            <Typography variant="h6">Duval Report</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <DuvalReport />
                                        </AccordionDetails>
                                    </Accordion>
                                </AccordionDetails>
                            </Accordion>
                        </Paper>
                        <br/></>}
                        
                        {this.state.transformer && <Paper elevation={6}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="predictions-content"
                                    id="predictions-header"
                                >
                                    <Typography variant="h6" >Predictive Analytics</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <Stack spacing={2}>

                                            <Paper elevation={3}>Predicted Days to Maintenance: <b>186 days</b><br />
                                                Highest probability failure: <b>Winding</b><br />
                                                Weibull Distribution calc: <b>0.63258</b><br />
                                            </Paper>
                                            <WeibullChart />
                                        </Stack>
                                    </Typography>
                                </AccordionDetails>

                            </Accordion>
                        </Paper>}


                        {this.state.circuitBreaker && <Paper elevation={6}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography variant="h6" >Digital Thread</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <Stack spacing={2}>
                                            <Paper elevation={3}>
                                                Category:
                                                <b>{this.state.circuitBreaker && 'Circuit Breaker'}</b>                                                
                                            </Paper>
                                            <Paper elevation={3}>Installation Date: <b>Jun 12, 2014</b><br />
                                                Operating Age: <b>11,692 hrs</b><br />
                                                No. Of Cycles: <b>127 open/close</b><br />
                                                Down Time: <b>1,446 hrs</b><br />
                                                Criticality: <b>Level 5 </b><br />
                                            </Paper>
                                            <Paper elevation={3}>Work Orders: <Badge badgeContent={2} color="primary"><WorkHistoryIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button><br />
                                                Alarms and Notices: <Badge badgeContent={1} color="primary"><NotificationsNoneIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button><br />
                                                Connected Sensors: <Badge badgeContent={2} color="primary"><SensorsIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button><br />
                                                Manufacturers docs: <Badge badgeContent={1} color="primary"><ArticleIcon color="action" /></Badge> <Button href="#text-buttons">View all</Button>
                                            </Paper>
                                        </Stack>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </Paper>}

                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default PredictionAnalytics;
